import {cs} from "@Common/react/chain-services";
import {ui} from "@Common/ui-components/heavy/item-options/modules/expo-types/expo-types";

import {IsShowPricing} from "../../../../../common/check-show-pricing";
import {PricingLink}   from "../../minors/pricing-link/pricing-link";

import {DeliveryMethods} from "./delivery-methods";

export const deliveryMethodsModules = ({templateOptions, item}) => [
    {
        load: ({deliveryMethod1}, next) => cs(
            ["showPricing", (_, next) => IsShowPricing({next})],
            ({showPricing}) => next({
                ui: DeliveryMethods({
                    state: deliveryMethod1.ui,
                    templateOptions,
                    item,
                    extra: showPricing && (
                        () => PricingLink({templateOptions})
                    ),
                }),
            }),
        ),
        expo: [ui("deliveryMethod")],
        requires: ["deliveryMethod1"],
    },
];